import { render } from "./PinDeleteModal.vue?vue&type=template&id=473256b0&scoped=true"
import script from "./PinDeleteModal.vue?vue&type=script&lang=js"
export * from "./PinDeleteModal.vue?vue&type=script&lang=js"

import "./PinDeleteModal.vue?vue&type=style&index=0&id=473256b0&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-473256b0"

export default script